import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import Modal from '../../../../common/Modal'
import { displayWithCurrency } from '../../../../../utility/currency'

import styles from './WhyTwoChargesModal.module.scss'

const WhyTwoChargesModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation()
  const course = useSelector(state => state.programPresentation.course)
  const plans = course.membership?.plans || []

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t('programs.landing.whyTwoCharges.title')} className={styles.modal}>
      <h3 className={styles['section-title']}>{t('programs.landing.whyTwoCharges.coachingFeeTitle')}</h3>
      <p className={styles['section-body']}>
        {t('programs.landing.whyTwoCharges.coachingFeeBody', { community: course.community.name })}
      </p>
      <h3 className={styles['section-title']}>{t('programs.landing.whyTwoCharges.membershipTitle')}</h3>
      <p className={styles['section-body']}>{t('programs.landing.whyTwoCharges.membershipBody')}</p>
      {!!plans.length && (
        <div className={styles.breakdown}>
          <p className={styles['breakdown-title']}>{t('programs.landing.whyTwoCharges.breakdownTitle')}</p>
          {plans.map(plan => (
            <div key={plan.id} className={styles['breakdown-row']}>
              <span>
                {t('programs.landing.whyTwoCharges.planPrice', {
                  tier: t(`programs.registration.membershipPlan.tiers.${plan.tier}`),
                  price: displayWithCurrency(plan.amount, plan.currency, true),
                })}
              </span>
              <span className={styles['breakdown-seats']}>
                {plan.seats > 1
                  ? t('programs.landing.whyTwoCharges.planSeatsUpTo', { count: plan.seats })
                  : t('programs.landing.whyTwoCharges.planSeats', { count: plan.seats })}
              </span>
            </div>
          ))}
        </div>
      )}
    </Modal>
  )
}

WhyTwoChargesModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default WhyTwoChargesModal
